import { createAction } from 'redux-actions';

export const updateViewModeAction = createAction('UPDATE_VIEWMODE');
export const updateAggregatePageTypeAction = createAction('UPDATE_AGGREGATE_PAGE_TYPE');
